import { OrderEntryUnit } from "~/gql/graphqlBase.generated";

export interface EntryUnitOrder {
	orderEntryUnit?: null | OrderEntryUnit;
	orderId?: null | string;
}

export interface EntryUnitCustomer {
	effectiveOrderEntryUnit?: null | OrderEntryUnit;
}

export const LEGACY_ORDER_ENTRY_UNIT = OrderEntryUnit.ShippingUom;

const orderEntryUnitFor = (
	order: EntryUnitOrder | null | undefined,
	customer: EntryUnitCustomer | null | undefined
): OrderEntryUnit =>
	order?.orderId
		? (order.orderEntryUnit ?? LEGACY_ORDER_ENTRY_UNIT)
		: (customer?.effectiveOrderEntryUnit ?? LEGACY_ORDER_ENTRY_UNIT);

export default orderEntryUnitFor;
